import { defineMessages } from 'react-intl';

export default defineMessages({
  privacyText: {
    id: 'TermsOfUse.privacyText',
    description: 'Privancy Policy details',
    defaultMessage: 'By submitting your order, you agree to our',
  },
  privacyPlicyText: {
    id: 'TermsOfUse.privacyPlicyText',
    description: 'privacy policy',
    defaultMessage: 'privacy policy',
  },
  privacyConnector: {
    id: 'TermsOfUse.privacyConnector',
    description: 'privacy policy text connector',
    defaultMessage: 'and',
  },
  termsOfUse: {
    id: 'TermsOfUse.termsOfUse',
    description: 'privacy policy terms of use',
    defaultMessage: 'terms of use',
  },
});
